import styled from 'styled-components';

// ----------------------------------------------------------------------

export const MainVisual = styled.div`
  width: 100%;
  height: calc(100vh - 300px);
  background-image: url(/assets/main/bg.svg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;